// extracted by mini-css-extract-plugin
export var orderDetails = "_s0-2";
export var orderImage = "_s0-1";
export var orderMeta = "_s0-3";
export var orderSummary = "_s0-0";
export var rightArrow = "_s0-4";